import React from "react";
import { contentDE } from "./contentDE";
import { useTitle } from "libs/useTitle";
import { useSelector } from "react-redux";
import { userSelectors } from "features/userSlice";
import { contentFR } from "./contentFR";
import { contentIT } from "./contentIT";

export const PrivacyPolicyPage = () => {
    const language = useSelector(userSelectors.language);
    const title = {
        'de': 'Datenschutzrichtlinien',
        'fr': 'Directives de protection des données',
        'it': 'Informativa sulla Privacy'
    }
    const content = {
        'de': contentDE,
        'fr': contentFR,
        'it': contentIT
    }

    useTitle(title[language]);

    return <>
        <div className="container-fluid policy-page">
            {content[language]}
        </div>
    </>
}
